var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    color: "#FFF"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentcolor",
    fillRule: "nonzero",
    d: "m23.056 25-8.75-8.75a8.465 8.465 0 0 1-5.278 1.806q-3.785 0-6.406-2.622Q0 12.812 0 9.028q0-3.785 2.622-6.406Q5.243 0 9.028 0t6.406 2.622 2.622 6.406a8.47 8.47 0 0 1-1.806 5.278l8.75 8.75zM9.028 15.278q2.604 0 4.427-1.823t1.823-4.427T13.455 4.6q-1.823-1.824-4.427-1.823-2.604 0-4.427 1.823-1.824 1.822-1.823 4.427 0 2.604 1.823 4.427t4.427 1.823"
  })));
};
export default SvgSearch;